import HelpCircleIcon from '@assets/icons/help-circle.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { Pressable } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  onPress: () => void;
}

export const PricingAgentHelpIconButton: React.FC<Props> = ({ onPress }) => {
  const theme = useTheme();

  return (
    <Pressable
      accessibilityLabel={i18n.t(
        'pricing.agent.review.help_modal.help_button_a11y',
      )}
      accessibilityRole="button"
      hitSlop={12}
      onPress={onPress}
    >
      <HelpCircleIcon
        height={24}
        stroke={theme.sk.color.icon.secondary}
        width={24}
      />
    </Pressable>
  );
};
